<template>
    <div>
      <div class="cover"></div>
        <div class="primapag"> 
          <div class="title">
            <span style="text-transform:capitalize;">A 30 ANNI DALLA CADUTA DEL MURO</span>
            <br>
            <div class="underline_text"></div>  
          </div>
          
          <div class="testo_cover">
            <br>
              <easy-typer :text="introduzione"
                :time="10000" class="sottotitolo" ></easy-typer>
              </div>


                <div class="cnt_car" v-if="loader.percentage!==1">
                  <div class="caricamento" :style="{
                      'width': `${loader.percentage * 100}%`,}">
                  </div>
                </div>
                        
                <div class="cnt_cerchi">
                  <router-link class="button"  v-if="loader.percentage==1" to="/orologio"> Esplora la Storia
                    <!-- <div class="circle" style="animation-delay: 0s"></div>
                    <div class="circle" style="animation-delay: 1s"></div>
                    <div class="circle" style="animation-delay: 2s"></div>
                    <div class="circle" style="animation-delay: 3s"></div>
                    <button id="myButton" class="btn"></button> --> 
                  </router-link> 
                </div>

<!--             <p class="testo">Esplora la storia</p>-->    
                <!-- <router-link to="/orologio"> 
                  <div class="circle" style="animation-delay: 0s"></div>
                  <div class="circle" style="animation-delay: 1s"></div>
                  <div class="circle" style="animation-delay: 2s"></div>
                  <div class="circle" style="animation-delay: 3s"></div>
                  <button id="myButton" class="btn"></button>
                </router-link>
             -->
        </div>
                
        </div>
</template>

<script>
import { VueTyper } from 'vue-typer';
import EasyTyper from '../components/EasyTyper';
import  Loader from '../lib/loader';
import  {TimelineMax, TweenMax, Power4} from "gsap";

export default {
    name: 'prima-pagina',
    components: { 
      VueTyper, EasyTyper
    },
    data(){
      return{ 
        loader: null,
        percenutale: 0,
        introduzione: "Mi ballano in testa i ricordi, no, non dei ricordi qualsiasi, ma quelli dopo la magnifica caduta del Muro, quando siamo, come dire... venuti in contatto. ~ Clemens Meyer in \"Eravamo dei grandissimi\""
      }
    },
    mounted() {
      this.loader = new Loader([
        "/assets/immagini/orologio/novara.jpg",
        "/assets/immagini/orologio/costruzione_muro.jpg",
        "/assets/immagini/orologio/stasi.jpg",
        "/assets/immagini/anastasiya/anastasiya_e_altri.jpg", //2
        "/assets/immagini/rechlin/base4.png",//2
        "/assets/immagini/orologio/caduta_muro.jpg",
        "/assets/immagini/orologio/italia_900.jpg",
        "/assets/immagini/altre_foto/pci.png",//2
        "/assets/immagini/altre_foto/dc.png",//2
        "/assets/immagini/orologio/berlino.jpg",
        "/assets/immagini/altre_foto/brandeburgo.jpg",//2
        "/assets/immagini/altre_foto/meyer.jpg",//2
        "/assets/immagini/orologio/mondo.jpg",
        
        // /*ANASTASIA */
        // "/assets/immagini/anastasiya/accordo_eventi.jpg", //dovrebbe funzionare così però non so
        // "/assets/immagini/anastasiya/anastasiya_a_rechlin.jpg",
        // "/assets/immagini/anastasiya/anastasiya_e_altri.jpg",
        // "/assets/immagini/anastasiya/attestato1.jpg",
        // "/assets/immagini/anastasiya/attestato2.jpg",
        // "/assets/immagini/anastasiya/villaggio_base.jpg",
        // /*CARTINE */
        // "/assets/immagini/cartine/disoccupazione_germania.jpg",
        // "/assets/immagini/cartine/eta_m_germania.jpg",
        // "/assets/immagini/cartine/produttivita_germania.jpg",        
        // "/assets/immagini/cartine/germania_unita.png",
        // "/assets/immagini/cartine/germania_divisa.png",
        // /*GIORNALI */
        // "/assets/immagini/giornali/giornali_1.jpg",
        // "/assets/immagini/giornali/giornali_3.jpg",
        // "/assets/immagini/giornali/giornali_4.jpg",
        // "/assets/immagini/giornali/giornali_9.jpg",
        /*MURI */
        "/assets/immagini/muri/muro1.jpg",
        "/assets/immagini/muri/muro2.jpg",
        "/assets/immagini/muri/muro1.jpeg",
        "/assets/immagini/muri/muro2.jpeg",
        // /*RECHLIN*/
        // "/assets/immagini/rechlin/2.png",
        // "/assets/immagini/rechlin/base.png",
        // "/assets/immagini/rechlin/base2.png",
        // "/assets/immagini/rechlin/base3.png",
        // "/assets/immagini/rechlin/base4.png",
        // "/assets/immagini/rechlin/foto_aerea.png",
        // "/assets/immagini/rechlin/galland_speer.png",
        // "/assets/immagini/rechlin/hitler_base.jpg",
        // "/assets/immagini/rechlin/pianta_base.png",
        // "/assets/immagini/rechlin/russi_base.jpg",
        // /*STASI */
        // "/assets/immagini/stasi/stasi1.jpg",
        // "/assets/immagini/stasi/stasi2.jpg",
        // "/assets/immagini/stasi/stasi3.jpg",
        // "/assets/immagini/stasi/stasi4.jpg",
        // "/assets/immagini/stasi/stasi5.jpg",
        // "/assets/immagini/stasi/stasi6.jpg",
        // "/assets/immagini/stasi/stasi7.jpg",
        // "/assets/immagini/stasi/testo_introduttivo.jpg",
        // /*PARTIGIANI */
        // "/assets/immagini/partigiani_pace/partigiani_4.jpg",
        // "/assets/immagini/partigiani_pace/partigiani_5.jpg",
        // "/assets/immagini/partigiani_pace/partigiani_6.jpeg",
        // /*COSTRUZIONE MURO */
        // "/assets/immagini/costruzione_muro/muro1.jpg",
        // "/assets/immagini/costruzione_muro/muro2.jpg",
        // "/assets/immagini/costruzione_muro/muro3.jpg",
        // "/assets/immagini/costruzione_muro/muro4.jpg",
        // "/assets/immagini/costruzione_muro/muro5.jpg",
        /*OROLOGIO*/
        "/assets/immagini/orologio/novara.jpg",
        "/assets/immagini/orologio/caduta_muro.jpg",
        "/assets/immagini/orologio/costruzione_muro.jpg",
        "/assets/immagini/orologio/stasi.jpg",
        "/assets/immagini/orologio/muri.jpg",
        "/assets/immagini/orologio/italia_900.jpg",
        "/assets/immagini/orologio/berlino.jpg",
        "/assets/immagini/orologio/mondo.jpg",
        // /*ALTRE FOTO */
        // "/assets/immagini/altre_foto/dc.png",
        // "/assets/immagini/altre_foto/pci.png",
        // "/assets/immagini/altre_foto/brandeburgo.jpg",
        // "/assets/immagini/altre_foto/meyer.jpg",
        // "/assets/immagini/altre_foto/meyer.jpeg",
        // /*MURO DEI MURI */
        // "/assets/immagini/muro_dei_muri/testo1.jpg",
        // "/assets/immagini/muro_dei_muri/testo2.jpg",
        // "/assets/immagini/muro_dei_muri/testo3.jpg",
        // "/assets/immagini/muro_dei_muri/testo4.jpg",
        // "/assets/immagini/muro_dei_muri/testo5.jpg",
        // "/assets/immagini/muro_dei_muri/testo6.jpg",
        // "/assets/immagini/muro_dei_muri/testo7.jpg",
        // "/assets/immagini/muro_dei_muri/testo8.jpg",
        // "/assets/immagini/muro_dei_muri/testo9.jpg",
        // "/assets/immagini/muro_dei_muri/testo10.jpg",
        // "/assets/immagini/muro_dei_muri/testo11.jpg",
        // "/assets/immagini/muro_dei_muri/testo12.jpg",
        // "/assets/immagini/muro_dei_muri/testo13.jpg",
        /*ARCHIVIO */
        "/assets/immagini/archivio/archivio1.jpg",
        "/assets/immagini/archivio/archivio2.jpg",
        "/assets/immagini/archivio/archivio3.jpg",
        "/assets/immagini/archivio/archivio4.jpg",
        "/assets/immagini/archivio/archivio5.jpg",
        "/assets/immagini/archivio/archivio6.jpg",
        "/assets/immagini/archivio/archivio7.jpg",
        "/assets/immagini/archivio/archivio8.jpg",
        "/assets/immagini/archivio/archivio9.jpg",
        "/assets/immagini/archivio/archivio10.jpg",
        "/assets/immagini/archivio/archivio11.jpg",
        "/assets/immagini/archivio/archivio12.jpg",



      ], this.cambioPercentuale.bind(this));

      

      this.loader.start();
    },    
    methods: {
      cambioPercentuale(per) {
        this.percentuale = per;
      }
    } 
}

    
</script>

<style scoped>
.testo_cover{
  position: absolute;
  transform: translate(-50%,-50%);
  top: 50%;
  left: 50%;
  line-height: 32.5px;/* In questo caso il numero è molto alto perchè si è sicuri di cogliere l'attenzione, visto che è la prima pagina visibile */
  word-spacing: 2.5px;
  text-align: justify;
  z-index: 2;
  font-size: 17.6px;
}

.title{
  color: var(--primary-color);
  font-weight: bold;
  width: 100%;
  margin-bottom: 10%;
  height: 2.3em;
  text-align: center;
  /* text-transform: uppercase; */
  font-size: 45px;
  position: absolute;
  transform: translate(-50%,-50%);
  top: 25%;
  left: 50%;
  z-index: 2;
}
.cover {
    background-image: url("https://66.media.tumblr.com/ddda16f190cff40b7b84dd81ab175a43/tumblr_mqdvhginCc1rm9sqwo8_400.gifv");
    background-position: center center;
    background-size: cover; 
    filter: brightness(40%);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    opacity: .5;
}

.primapag{
    background-color: black;
    background-size: cover;
    height: 100vh;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
}

.principale {
/*     background-image: url("https://i.pinimg.com/originals/c4/02/23/c4022305996038acf5a32997549573dd.jpg");
 */    background-size: cover;
    height: 100vh;
    width: 100%;
    position: relative;
    z-index: 2;
    margin-bottom: 5%;
    opacity: 1;
    /* background-color: red; */
}
.sottotitolo {
  color: var(--primary-color);
  text-align: justify;
}
.titolo_sezione {
    margin: 0;
    padding: 0;
    position: relative;
    top: 50%;
    color: var(--primary-color);
    text-align: center;
}


/*CERCHIO*/

@keyframes scaleIn {
    from {
        transform: scale(.5, .5);
        opacity: .5;
    }
    to {
        transform: scale(2.5, 2.5);
        opacity: 0;
    }
}

.circle {
    border-radius: 50%;
    background-color: var(--primary-color);
    width: 50px;
    height: 50px;
    position: absolute;
    opacity: 0;
    animation: scaleIn 4s infinite cubic-bezier(.36, .11, .89, .32);
}

.cnt_cerchi {
    cursor: pointer;
    position: absolute; 
    display: flex;
    justify-content: center;
    bottom: 5%;
    width: 100%; 
    z-index: 2;
}

.btn {
    opacity: 0;
    cursor: pointer;
    cursor: pointer;
    position: absolute;
    width: 50px;
    height: 50px;
}

.testo{
    color: var(--primary-color);
    margin: 0;
    padding-top: 30vh;
    font-family: 'Hammersmith One', sans-serif;
    font-size: 100px;
    text-align: center;
}


/*TESTO 3 */
.testo3{
    color:var(--primary-color);
    text-align: center;
    margin:0;
    font-family: 'Hammersmith One', sans-serif;
    font-size: 100px;
    position: absolute;
}

/* FRECCIA GIU*/

.arrow {
  box-sizing: border-box;
  height: 5vw;
  width: 5vw;
  border-style: solid;
  border-color: var(--primary-color);
  border-width: 0px 1px 1px 0px;
  transform: rotate(45deg);
  transition: border-width 150ms ease-in-out;
  cursor: pointer;
  position: absolute;
  left: 47.5vw;
  bottom: 15%;


}

.arrow:hover {
  border-bottom-width: 4px;
  border-right-width: 4px;
}

/*LINEA DI CARICAMENTO */
.cnt_car{
  /* background-color: grey; */
  position: absolute;
  left: 5vw;
/*   bottom: 5%; */
/*   width: 90vw;*/  
  height: 5px;
  margin: 0;
  padding: 0;

  /* fatto da youssef cancellare se non piace */
  bottom: 15%;
  width: 40%;
  margin-left: 25%;
  z-index: 10;
}

.caricamento{
  background-color: var(--secondary-color);
  position: absolute;
  height: 5px;
  margin: 0;
  padding: 0;
}


.underline_text{
    background-color: var(--secondary-color);
    height: 10px;
    width: 200px; 
    left: calc( 50% - 100px ); 
    bottom: 0;
    position: absolute;
}

 

.button {
    padding:10px 35px 10px 35px; 
    /* font-size: 1.1em;
    font-weight: bold; */
    color: var(--background-color);
    border-radius: 15px;
    background-color: var(--primary-color);
    text-decoration: none;
    margin: 15px;
    color: var(--secondary-color);
    transition: .8s;
}

.button:hover{
    /* padding:5px 45px 5px 45px;  */
    color: var(--background-color);
    border-radius: 15px;
    background-color: var(--secondary-color);
    text-decoration: none;
    margin: 15px;
    color: var(--primary-color);
    transition: 0.4s;
}


/*DA FARE: COLLEGAMENTO CON PERCENTUALE */
</style>